import { Paper, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export const ResendMessage = () => {
	const { translate } = useLocales();
	return (
		<Paper sx={{ p: 3, mt: 2, backgroundColor: "primary.lighter" }}>
			<Typography variant='subtitle1'>{translate("demo.resend_1")}</Typography>
			<Typography sx={{ mt: 1 }} variant='body2' color='text.secondary' maxWidth={600}>
				{translate("demo.resend_2")}
			</Typography>
		</Paper>
	);
};

export default ResendMessage;
